/** A canonical language tag, never arbitrary text that could become model instructions. */
export function canonicalLocale(value) {
    if (typeof value !== 'string' || value.length > 64 || !/^[a-zA-Z0-9-]+$/.test(value))
        return undefined;
    try {
        return Intl.getCanonicalLocales(value)[0];
    }
    catch {
        return undefined;
    }
}
/** Read at request time, so changing the device language does not require a new client. */
export function getDeviceLocale(preferred = []) {
    for (const candidate of preferred) {
        const locale = canonicalLocale(candidate);
        if (locale !== undefined)
            return locale;
    }
    try {
        return canonicalLocale(Intl.DateTimeFormat().resolvedOptions().locale) ?? 'en';
    }
    catch {
        return 'en';
    }
}
//# sourceMappingURL=locale.js.map